import { toast } from "react-toastify";

import { useMutation } from "@apollo/client";
import { ForecastActivityType } from "constants/settings.constants";

import { FOLDERS, MOVE_FOLDER } from "api/userArps";

import { useSelectedProject } from "components/project/projects/hooks";

export interface MoveFolderRequest {
  folderId: string;
  oldParentId: string;
  newParentId: string;
  type: ForecastActivityType;
  order: number;
}

export const useMoveFolder = (forecastType: ForecastActivityType) => {
  const { selectedProject: project } = useSelectedProject();

  const [moveFolderMutation, { loading, error }] = useMutation(MOVE_FOLDER);

  const moveFolder = async (input: MoveFolderRequest) => {
    await moveFolderMutation({
      variables: {
        input
      },
      refetchQueries: [
        {
          query: FOLDERS,
          variables: { req: { projectId: project?.projectId, type: forecastType } }
        }
      ],
      onError: (err) => {
        toast.error(err.message);
      }
    });
  };

  return { move: moveFolder, loading, error };
};
